export const calculateTotalLeadTime = (bookingList) => {
  const totalLeadTime = bookingList.reduce((sum, booking) => {
    const createdAt = new Date(booking.createdAt);
    createdAt.setUTCHours(0, 0, 0, 0);
    const fromdateParts = booking.fromdate.split("-");
    const [day, month, year] = fromdateParts.map(Number);
    const fromDate = new Date(Date.UTC(year, month - 1, day));
    const leadTime = (fromDate - createdAt) / (1000 * 60 * 60 * 24);
    return leadTime >= 0 ? sum + leadTime : sum;
  }, 0);
  const totalBookings = bookingList.length;
  return totalBookings > 0
    ? Number((totalLeadTime / totalBookings).toFixed(2))
    : 0;
};
